import ReducerUtils                         from "../../../utils/ReducerUtils"
import Actions                              from "../../../model/constant/actions"

const retrievingDefaultAds = ReducerUtils.createReducer(false,{
  [Actions.RETRIEVING_BRANDING_DEFAULT_AD_SET] : (state,action)=>action.status,
})

export default retrievingDefaultAds
